import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_ENDPOINTS } from "../../shared/constants/constants";
import { useCustomAxios } from "../../shared/lib/customAxios";

export const createFacility = createAsyncThunk(
    'facility/create',
    async (reqBody:any)=> {
        const { axiosPost } = useCustomAxios();
        try {
          const url = API_ENDPOINTS.createFacility;
          const response = await axiosPost(url, reqBody);
  
            return { data: response.data, status: response.status };
          } catch (error: any) {
            return {
              error: error.response.data.message,
              status: error.response.status,
            };
          }
    }
  )

export const updateFacility = createAsyncThunk(
    'facility/update',
    async (reqBody:any)=> {
        const { axiosPost } = useCustomAxios();
        try {
          const url = API_ENDPOINTS.updateFacility;
          const response = await axiosPost(url, reqBody);
  
            return { data: response.data, status: response.status };
          } catch (error: any) {
            return {
              error: error.response.data.message,
              status: error.response.status,
            };
          }
    }
  )

export const searchFacilities = createAsyncThunk(
    'facility/search',
    async (data:any)=> {
        const { axiosPost } = useCustomAxios();
        const {queryParams, reqBody} = data;
        try {
          let url = API_ENDPOINTS.searchFacilities;
          Object.entries(queryParams).forEach(
            ([key, value], index) =>
              (url = url + `${index > 0 ? '&' : '?'}${key}=${value}`)
          );
          const response = await axiosPost(url, reqBody);
  
            return { data: response.data, status: response.status };
          } catch (error: any) {
            return {
              error: error.response.data.message,
              status: error.response.status,
            };
          }
    }
  )

export const getFacilityById = createAsyncThunk(
    'facility/getById',
    async (facilityId: string)=> {
        const { axiosGet } = useCustomAxios();
        try {
          let url = API_ENDPOINTS.getFacilityById;
          url = url.replace(":facilityId", facilityId);
          const response = await axiosGet(url);
  
            return { data: response.data, status: response.status };
          } catch (error: any) {
            return {
              error: error.response.data.message,
              status: error.response.status,
            };
          }
    }
  )